module.exports = __webpack_public_path__ + "img/icon.1e743cb2.png";